import React, {useContext, useEffect, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import {
    Alert,
    Button,
    ButtonGroup,
    CardHeader,
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    Typography
} from "@mui/material";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import {Close, Delete} from "@mui/icons-material";
import {Link} from "react-router-dom";


function RegisterChildren(props) {
    const title = 'Zapisy';

    const [user] = useContext(AuthContext);
    const [children, setChildren] = useState([]);
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchChildren() {
            await fetch(`/api/camp/${props.data}/register`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setChildren(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchChildren();
        return () => abortController.abort();
    }, [props.data, refresh, user.token])

    function _send(id) {
        fetch(`/api/camp/${props.data}/register/${id}`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }

    function _delete(id) {
        fetch(`/api/registration/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                setRefresh(r => ++r);
            })
            .catch(err => {
                console.log(err)
            })
    }

    let cards = children.map(c => {
        const rStart = new Date(c.registration_start) > new Date();
        let action = <Button color={c.priority ? 'primary' : 'gray'} variant={'contained'}
                             onClick={() => _send(c.id)} disabled={rStart}>
            {rStart ? `Od ${c.registration_start}` : 'Zapisz'}
        </Button>;
        if (c.advanced && !c.document) {
            action = <Link to={`/season/${c.season_id}/advanced`}><Button color={'warning'} variant={'outlined'}>Przygotuj dokumenty</Button></Link>;
        }
        if (!c.priority && c.no_reserve) {
            action = '';
        }
        if (c.registration) {
            if (c.paid) {
                action = <ButtonGroup>
                    <Button fullWidth variant={'outlined'} color={'success'}>Zawarta Umowa</Button>
                    <Button variant={'contained'} color={'error'} onDoubleClick={() => _delete(c.registration)}><Delete /></Button>
                </ButtonGroup>
            } else if (c.confirmed) {
                action = <ButtonGroup>
                    <Button fullWidth variant={'outlined'} color={'primary'}>Potwierdzony</Button>
                    <Button variant={'contained'} color={'error'} onDoubleClick={() => _delete(c.registration)}><Delete /></Button>
                </ButtonGroup>
            } else if (c.deleted) {
                action = <ButtonGroup>
                    <Button fullWidth variant={'outlined'} color={'error'}>Usunięty</Button>
                </ButtonGroup>
            } else {
                action = <ButtonGroup>
                    <Button fullWidth variant={'outlined'} color={'warning'}>Rezerwowy</Button>
                    <Button variant={'contained'} color={'error'} onDoubleClick={() => _delete(c.registration)}><Delete /></Button>
                </ButtonGroup>
            }
        }
        if (c.closed) {
            action = <Button color={'error'} variant={'text'}>Zakończona</Button>;
        }

        return (<Card key={c.id}>
            <CardHeader title={`${c.name} ${c.surname}`} action={action} />
            {!c.priority && !c.no_reserve &&
                <Alert severity="error">Twoje dziecko nie spełnia wymagań podstawowych tego organizatora. Zapis możliwy
                    tylko na listę rezerwową</Alert>}
            {!c.priority && c.no_reserve &&
                <Alert severity="error">Twoje dziecko nie spełnia wymagań podstawowych tego organizatora. Brak możliwości zapisu</Alert>}
        </Card>);
    });
    const closeCss = {
        position: 'absolute',
        right: 8,
        top: 8
    };

    if (children.length === 0) {
        cards = <Link to={'/children'} style={{width: '100%'}}><Button fullWidth>Uzupełnij dzieci w systemie</Button></Link>;
    }

    return (<Dialog open={props.data} onClose={props.dismiss} fullWidth maxWidth={'sm'}>
        <DialogTitle>
            <IconButton variant={'text'} onClick={props.dismiss} sx={closeCss}><Close/></IconButton>
            <Typography variant={'h5'} fontWeight={'light'}>{title}</Typography>
        </DialogTitle>
        <DialogContent>
            <Stack spacing={2}>
                {cards}
            </Stack>
        </DialogContent>
    </Dialog>);
}

export default RegisterChildren;